import { QuestionnaireItemDto } from "@libs/gateways/clinical/ClinicalGateway.dtos.ts";
import { required } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

export class ClinicalToolFormValidator extends Validator<any> {
  constructor(questions: QuestionnaireItemDto[]) {
    super();
    questions.forEach(question => {
      this.forField(`q${question.id}`, required());
    });
  }
}
